<template>
    <div class="start__container">
        <span class="start__title">{{ $t("lang.pages.tariff.start.title") }}</span>
        <span class="start__description">{{ $t("lang.pages.tariff.start.description") }}</span>
        <div class="start__button_container">
            <a :href="getRegisterLink" class="start__button">{{ $t("lang.pages.tariff.start.button") }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "TariffPageStart",
    props: {
        locale: String
    },
    computed: {
        getRegisterLink() {
            return '/' + this.locale + '/registration';
        }
    }
}
</script>

<style scoped>
.start__container {
    display: flex;
    flex-direction: column;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 80px;
}
.start__title {
    display: inline-block;
    font-size: 36px;
    line-height: 40px;
    margin-bottom: 4px;
}
.start__description {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
}
.start__button {
    display: inline-block;
    padding: 12px 85px;
    background-color: #70B319;
    border-radius: 4px;
    text-decoration: none;
    color: #fff;
}
</style>
